import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import TurnoActual from "../../components/estudiantes/TurnoActual";

const styles = {
  body: {
    fontFamily: "var(--font-estudiantes)",
    backgroundColor: "#8CD870",
    minHeight: "100dvh",
    width: "100dvw",
    display: "flex",
    alignItems: "center",
  },
};

function EsTuTurno() {
  const location = useLocation();
  const navigate = useNavigate();

  const initialData = location.state;

  // Redirige si NO trae state
  useEffect(() => {
    if (!initialData) navigate("/inicio");
  }, [initialData, navigate]);

  // Mientras se redirige, no mostrar TurnoActual
  if (!initialData) return <p className="text-center mt-5">Cargando...</p>;

  return (
    <div style={styles.body}>
      <TurnoActual
        numero={initialData.numero_ticket}
        modulo={initialData.modulo?.numero || "1"}
      />
    </div>
  );
}

export default EsTuTurno;
